export default __webpack_public_path__ + "static/media/file-type-excel.d65751a5.svg";